/**
 * The collapse caret every box in the builder wears (Aaron, step 21 item 4.4).
 *
 * A visit, a package, a choice box and a billing plan each fold on their own,
 * so each carries the same control in the same place: first in the header,
 * before the tile, the tile indented a little behind it. It replaced the
 * "Expand" link a folded visit used to print at its foot — a control that
 * appeared only once the thing was closed, at the opposite end from where
 * somebody had just closed it.
 */
import { cn } from '../../lib/cn.js'
import { IconChevronDown } from '../../frame/icons.js'

export function CollapseCaret({ collapsed, onToggle, label }: {
  collapsed: boolean
  onToggle: () => void
  /** What folds — "Spring cleanup", "Your choice" — for the button's name. */
  label: string
}) {
  return (
    <button
      type="button"
      data-caret=""
      aria-expanded={!collapsed}
      aria-label={collapsed ? `Expand ${label}` : `Collapse ${label}`}
      onClick={(event) => { event.stopPropagation(); onToggle() }}
      className="-ml-1 -mr-1 flex h-8 w-6 shrink-0 items-center justify-center rounded-field
                 text-text-faint hover:bg-field hover:text-text"
    >
      <IconChevronDown size={16} className={cn('transition-transform', collapsed && '-rotate-90')} />
    </button>
  )
}
